import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";

export const SelectCustom = (props) => {
    
    const onTrigger = (event) => {
        event.target.value === "" ? setOnError(true) : setOnError(false);

        props.parentCallback(event);
    };

    const [value] = useState("");
    const [OnError, setOnError] = useState(false);

    return (
        <Grid container spacing={2} sx={{ pl: props.paddingH, pr: props.paddingH, pt: props.paddingV, pb: props.paddingV }}>
            <Grid item xs={12}>
                <FormControl fullWidth size="small" required={props.required} variant={props.variant}>
                    <InputLabel id="select-label">{props.label}</InputLabel>
                    <Select
                        defaultValue={value}
                        error={OnError}
                        id={props.name}
                        label={props.label}
                        name={props.name}
                        onChange={onTrigger}
                    >
                        {props.options.map((opt) => {
                            return (
                                <MenuItem key={opt.value+opt.label} value={opt.value}>
                                    {opt.label}
                                </MenuItem>
                            );
                        })}
                        variant={props.variant}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};
